import map from 'lodash/map'
import $ from 'jquery'
import Vue from 'vue'
import 'slick-carousel'
// eslint-disable-next-line import/no-unresolved
import PhotoSwipe from '@PhotoSwipe'
import '../component/SampleRequest'

import '../../../scss/app/leather.scss'

//
// Sample Request
//

const sampleRequestEl = document.querySelector('.js-sample-request-entry')
if (sampleRequestEl) {
  new Vue({ el: sampleRequestEl })
}

//
// Photos
//

const $bigSlides = $('.big-slides')
if ($bigSlides.length) {
  $bigSlides.slick({
    infinite: true,
    lazyLoad: 'progressive',
    adaptiveHeight: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
  })

  //
  // PhotoSwipe
  //

  const photos = map(window.APP.leatherPhotos, (photo) => ({
    src: window.APP.context.site.files_url + photo.path,
    w: photo.width,
    h: photo.height,
  }))

  $bigSlides.on('click', '.slide', (ev) => {
    ev.preventDefault()

    const gallery = new PhotoSwipe({
      index: $(ev.currentTarget).closest('.slick-slide').data('slick-index'),
      bgOpacity: 1,
      dataSource: photos,
    })
    gallery.init()
  })
}

const $thumbSlides = $('.thumb-slides')
if ($thumbSlides.length) {
  $thumbSlides.slick({
    asNavFor: '.big-slides',
    focusOnSelect: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: $('#slider-prev').html(),
    nextArrow: $('#slider-next').html(),
    centerMode: true,
    centerPadding: '60px',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
        },
      },
    ],
  })
}
